import { Grid, Typography } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { LabeledValue } from '../../../../../controls/labeled-value';
import { getCodeDescription, GetVerificationWidget } from '../../../../../shared-functions';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';
import { BankingDetails } from '../../../common/banking-details/banking-details';
import { ViewBankResponse } from '../../../common/banking-details/views/view-bank-response';

interface BankingProps {
    beneficiaryId?: string;
    claimType?: Nullable<ClaimType>;
    bankingDetails: BankingDetails[];
}

export const ViewBankingDetails: React.FunctionComponent<BankingProps> = ({
    bankingDetails,
    beneficiaryId,
    claimType,
}: BankingProps) => {
    if (bankingDetails[0] == null) {
        return null;
    }
    return (
        <React.Fragment>
            {bankingDetails.map((bankingDetails, index) => {
                return (
                    <Grid item xs={12} container justify="flex-start" key={index}>
                        <Grid item xs={12} container justify="flex-start">
                            <Typography variant="subtitle1" style={{ fontSize: '20px' }}>
                                Banking details({index + 1})
                            </Typography>
                        </Grid>
                        {bankingDetails.investmentIdType === 'Individual' && (
                            <>
                                <Grid item xs={6} lg={3}>
                                    <LabeledValue
                                        label="Account holder's initials"
                                        value={bankingDetails.accountHoldersInitials}
                                    />
                                </Grid>
                                <Grid item xs={6} lg={3}>
                                    <LabeledValue
                                        label="Account holder's surname/company name"
                                        value={bankingDetails.accountHoldersName}
                                    />
                                </Grid>
                            </>
                        )}
                        {bankingDetails.investmentIdType === 'Individual' && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label={`Account holder's ${getIdType(
                                        bankingDetails.accountHoldersIdType
                                    )} number`}
                                    value={bankingDetails.accountHoldersIdNumber}
                                />
                            </Grid>
                        )}
                        {bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label={`Company Registration number`}
                                    value={bankingDetails.accountHoldersIdNumber}
                                />
                            </Grid>
                        )}
                        <Grid item xs={6} lg={3}>
                            <LabeledValue
                                label="Bank name"
                                value={getCodeDescription('bankName', bankingDetails.bankName)}
                            />
                        </Grid>
                        {bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label="Company Name"
                                    value={bankingDetails.companyName}
                                />
                            </Grid>
                        )}
                        {bankingDetails.investmentIdType === 'CompulsoryAnnuity' && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label="Company reference"
                                    value={bankingDetails.companyReference}
                                />
                            </Grid>
                        )}
                        <Grid item xs={6} lg={3}>
                            <LabeledValue
                                label="Branch name"
                                value={getCodeDescription('branchname', bankingDetails.branchCode)}
                            />
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <LabeledValue label="Branch code" value={bankingDetails.branchCode} />
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <LabeledValue
                                label="Account number"
                                value={bankingDetails.accountNumber}
                            />
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <LabeledValue
                                label="Special Instructions"
                                value={bankingDetails.specialInstructions}
                            />
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <LabeledValue label="Account type" value={bankingDetails.accountType} />
                        </Grid>
                        {bankingDetails.accountHolderRelationship && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label="Account holder relationship"
                                    value={bankingDetails.accountHolderRelationship}
                                />
                            </Grid>
                        )}
                        {bankingDetails.accountHolderRelationshipDescription && (
                            <Grid item xs={6} lg={3}>
                                <LabeledValue
                                    label="Relationship description"
                                    value={bankingDetails.accountHolderRelationshipDescription}
                                />
                            </Grid>
                        )}
                        <Grid item xs={6} lg={3}>
                            <LabeledValue
                                label="Account status"
                                value={GetVerificationWidget(bankingDetails.bankAccountStatus)}
                            />
                        </Grid>
                        <ViewBankResponse
                            bankResponse={bankingDetails.bankResponse}
                            beneficiaryId={beneficiaryId}
                        />
                    </Grid>
                );
            })}
        </React.Fragment>
    );
};
function getIdType(idType?: string) {
    if (typeof idType === 'undefined' || idType === null || idType === '') {
        return '';
    } else {
        return idType === 'ID' ? idType : idType?.toLowerCase();
    }
}
